module.exports = __webpack_public_path__ + "img/trash.58b7e0d0.svg";